import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {

  transform(sentence: any, args?: any): string {
    if(sentence == '' || sentence== null || !isNaN)
      return null;
    
    sentence = sentence.toLowerCase();
    sentence = sentence.split(' ');

    for (var i = 0; i < sentence.length; i++)
    {
      if(sentence[i] != 'de')
        sentence[i] = sentence[i][0].toUpperCase() + sentence[i].substring(1);
    }
    sentence = sentence.join(' ');

    return sentence;
    
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/pipes/capitalize.pipe.ts